import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// In production, silence noisy/PII-leaking console output (keep warn & error for
// real issues). Development keeps full logging for debugging.
if (process.env.NODE_ENV === "production") {
  const noop = () => {};
  console.log = noop;
  console.debug = noop;
  console.info = noop;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
